/* eslint-disable no-unused-vars */
import { TableCell } from '@material-ui/core'
import { withStyles, createStyles } from '@material-ui/core/styles'

export enum Colors {
  red = 'red',
  orange = 'orange',
  yellow = 'yellow',
  green = 'green',
  blue = 'blue'
}

export type Props = {
  color: Colors
  children: string|number
}

const ColoredTableCell = withStyles(() =>
  createStyles({
    body: {
      textAlign: 'center',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      [`&.${Colors.red}`]: {
        color: '#dc3e44',
        backgroundColor: '#FFADB1'
      },
      [`&.${Colors.orange}`]: {
        color: '#EF6167',
        backgroundColor: '#FFDCDE'
      },
      [`&.${Colors.green}`]: {
        color: '#099461',
        backgroundColor: '#c7ebdb'
      },
      [`&.${Colors.blue}`]: {
        color: '#2c693f',
        backgroundColor: '#7bc382'
      },
      '&:first-child': {
        textAlign: 'left',
        minWidth: '120px'
      }
    }
  })
)(TableCell)

export const NestedColoredTableCell = withStyles(() =>
  createStyles({
    body: {
      maxWidth: 100,
      fontSize: 13,
      border: 'none',
      textAlign: 'center',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      [`&.${Colors.red}`]: {
        color: '#dc3e44',
        backgroundColor: '#FFADB1'
      },
      [`&.${Colors.green}`]: {
        color: '#099461',
        backgroundColor: '#c7ebdb'
      },
      [`&.${Colors.blue}`]: {
        color: '#1c4164',
        backgroundColor: '#9ED6EE'
      },
      '& div': {
        '&:nth-of-type(2)': {
          fontWeight: 'bold'
        }
      }
    }
  })
)(TableCell)

export default ColoredTableCell
